import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useNavigate } from 'react-router-dom';
const services = [{
  title: 'Kitchen Renovation',
  slug: 'kitchen-renovation',
  image: 'https://images.unsplash.com/photo-1556912167-f556f1f39fdf?w=800&q=80',
  description: 'Modern, functional, and luxurious kitchen designs.'
}, {
  title: 'Bathroom Renovation',
  slug: 'bathroom-renovation',
  image: 'https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=800&q=80',
  description: 'Elegant and futuristic bathroom transformations.'
}, {
  title: 'Full House Renovation',
  slug: 'full-house-renovation',
  image: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&q=80',
  description: 'Complete home renovations with premium finishes.'
}, {
  title: 'Flooring & Painting',
  slug: 'flooring-painting',
  image: 'https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=800&q=80',
  description: 'High-quality flooring and custom painting services.'
}, {
  title: 'Plumbing & Electrical',
  slug: 'plumbing-electrical',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/udKXTpCQCLPDCr4RZZ47z1/What_Do_Electrical_Engineers_Do.jpg',
  description: 'Reliable and professional services for all home systems.'
}, {
  title: 'Roofing Renovation',
  slug: 'roofing-renovation',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aPNuuyzSTsP9Z7jWz9hKeN/roofing_brisbrene.jpg',
  description: 'Durable and aesthetic roofing solutions.'
}, {
  title: 'New Builds',
  slug: 'new-builds',
  image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80',
  description: 'Futuristic and luxurious new home construction.'
}];
export function Services() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const navigate = useNavigate();
  return <section id="services" className="py-12 sm:py-16 md:py-20 bg-[#0f0f0f]" ref={ref} data-id="element-221">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-222">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-10 sm:mb-12 md:mb-16" data-id="element-223">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-4" data-id="element-224">
            Our <span className="text-[#d4af37]" data-id="element-225">Services</span>
          </h2>
          <p className="text-gray-400 text-base sm:text-lg max-w-2xl mx-auto px-4" data-id="element-226">
            Comprehensive renovation solutions tailored to your needs
          </p>
        </motion.div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-227">
          {services.map((service, index) => <motion.div key={service.title} initial={{
          opacity: 0,
          y: 30
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} onClick={() => navigate(`/services/${service.slug}`)} className="group relative overflow-hidden rounded-lg bg-[#1c1c1c] hover:shadow-2xl hover:shadow-[#d4af37]/20 transition-all duration-300 active:scale-95 cursor-pointer" data-id="element-228">
              <div className="relative h-48 sm:h-56 md:h-64 overflow-hidden" data-id="element-229">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-230" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1c1c1c] to-transparent" data-id="element-231" />
              </div>
              <div className="p-4 sm:p-6" data-id="element-232">
                <h3 className="text-xl sm:text-2xl font-bold text-white mb-2 sm:mb-3 group-hover:text-[#d4af37] transition-colors" data-id="element-233">
                  {service.title}
                </h3>
                <p className="text-gray-400 text-sm sm:text-base mb-4" data-id="element-234">
                  {service.description}
                </p>
                <span className="text-[#d4af37] text-sm font-semibold group-hover:gap-2 inline-flex items-center transition-all" data-id="element-235">
                  Learn More →
                </span>
              </div>
              <div className="absolute top-4 right-4 w-10 h-10 sm:w-12 sm:h-12 bg-[#d4af37] rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-236">
                <span className="text-[#1c1c1c] font-bold text-lg sm:text-xl" data-id="element-237">
                  →
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}